module.exports = __webpack_public_path__ + "img/resource-tech-image-48.e73121a4.jpg";